module.exports = __webpack_public_path__ + "static/media/andrzej.c874f1e1.jpg";